import React from 'react';

import classNames from 'classnames';

import './index.scss';

const Errors = ({ component: Component = 'div', errors, ...props }) => (
  <Component
    {...props}
    className={classNames(
      'errors',
      // eslint-disable-next-line react/destructuring-assignment
      props.className,
    )}
  >
    <div className="errors-list">
      {Object.keys(errors).map((errorKey) => (
        <p key={errorKey}>{errors[errorKey]}</p>
      ))}
    </div>
  </Component>
);

export default Errors;
